import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { CLASS_POSITION, FEATURE_SET } from './constants';

export const classPositionPropTypes = PT.oneOf(Object.values(CLASS_POSITION));
export const featureSetPropTypes = PT.oneOf(Object.values(FEATURE_SET));

export const schoolClassPropType = IPT.contains({
  school_class_id: PT.number.isRequired,
  school_class_title: PT.string.isRequired,
  course_id: PT.number.isRequired,
  course_title: PT.string.isRequired,
  feature_set: featureSetPropTypes,
  position: classPositionPropTypes,
});

export const profilePropType = IPT.contains({
  user_id: PT.number.isRequired,
  profile_id: PT.number.isRequired,
  display_name: PT.string.isRequired,
  is_teacher: PT.bool.isRequired,
  is_staff: PT.bool.isRequired,
  is_poc: PT.bool.isRequired,
  school_classes: IPT.mapOf(schoolClassPropType, PT.string).isRequired,
});
